import React from "react";

export const AccountOwnerRoutesContext = React.createContext();
